import { connect } from 'react-redux';
import AriaLiveAnnouncer from '../components/Accessibility/AriaLiveAnnouncer';

const mapStateToProps = (state) => ({
  message: state.announcements.message,
  timestamp: state.announcements.timestamp,
});

export default connect(mapStateToProps)(AriaLiveAnnouncer);
